import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from '@schoolbelle/common/table';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';
import { MemberStatusBadgeModule } from '@schoolbelle/shared/components';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { SelectLetterTargetsFacultyTabComponent } from './faculty-tab.component';

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    VirtualScrollerModule,
    PhoneNumberModule.forRoot(),
    MemberStatusBadgeModule,
  ],
  declarations: [SelectLetterTargetsFacultyTabComponent],
  exports:[SelectLetterTargetsFacultyTabComponent],
})
export class SelectLetterTargetsFacultyTabModule { }
